export default __webpack_public_path__ + "src/assets/desktop.3f050ff59b9a26c4bd468a883d8fad5a.svg";